import { ShieldCheckIcon, ChartBarIcon, UsersIcon } from '@heroicons/react/24/outline';
import PublicLayout from './PublicLayout';

// Placeholder copy — replace with the school's actual SPTA background/mission.
const highlights = [
  {
    icon: ShieldCheckIcon,
    title: 'Transparency',
    description: 'Every collection and disbursement is recorded and made available for parents and guardians to review.',
  },
  {
    icon: ChartBarIcon,
    title: 'Real-Time Records',
    description: "Check a student's payment status and see how funds are being used for school projects, anytime.",
  },
  {
    icon: UsersIcon,
    title: 'Community Involvement',
    description: 'The SPTA is run by parents, teachers, and school officials working together for the welfare of every learner.',
  },
];

function AboutPage() {
  return (
    <PublicLayout>
      <div className="w-full space-y-4">
        <section className="w-full bg-white rounded-lg border border-gray-200 p-4">
          <p className="-mx-4 -mt-4 mb-3 rounded-t-lg bg-navy-light px-4 py-2 text-md lg:text-lg font-semibold text-white tracking-wide">
            ABOUT THE SPTA FINANCIAL PORTAL
          </p>

          <div className="space-y-3 text-sm text-gray-700 leading-relaxed">
            <p>
              The School-Parent-Teacher Association (SPTA) is a partnership between parents, teachers, and
              school administrators dedicated to supporting the welfare, safety, and development of every
              learner. Through voluntary contributions, the SPTA helps fund school projects, facility
              improvements, and student activities that the regular school budget may not cover.
            </p>
            <p>
              This portal was built so that every peso collected — and every peso spent — is visible to the
              families who contribute it. Parents and guardians can look up their child's payment record,
              browse ongoing and completed projects, and see exactly where SPTA funds are going, without
              needing to log in or visit the school office.
            </p>
            <p>
              We believe financial transparency builds trust, and trust is what makes a school community
              strong.
            </p>
          </div>
        </section>

        <section className="grid grid-cols-1 sm:grid-cols-3 gap-4">
          {highlights.map(({ icon: Icon, title, description }) => (
            <div key={title} className="bg-white rounded-lg border border-gray-200 p-5 flex flex-col gap-3">
              <Icon className="h-8 w-8 text-navy-light" />
              <div>
                <h3 className="font-semibold text-gray-900">{title}</h3>
                <p className="text-sm text-gray-500 mt-1">{description}</p>
              </div>
            </div>
          ))}
        </section>
      </div>
    </PublicLayout>
  );
}

export default AboutPage;
